// Error code returned by Backend where the basket is not compatible with the current menu
export const INVALID_BASKET_ERROR_CODE = 10608;
